// @ts-nocheck

import { reduce, isPlainObject } from 'lodash';

import { TIMER_INCREMENT, TIMER_DECREMENT, TIMER_STOP } from '../constants/timer';
import { SportIds } from '../types/sports';
import MatchStateUtils from '../utils/match';
import NumberUtils from '../utils/number';

import { getTimerFromMatchTimeExtended } from './date';

const convertToLowerCase = (value) => value && value.toLowerCase && value.toLowerCase();

const convertToString = (value) => value && value.toString && value.toString();

const normalizeEntities = (entities, entityIdName) =>
  reduce(
    Object.keys(entities),
    (finalEntities, key) => {
      const fEntitiesRef = finalEntities;
      const model = entities[key];
      if (model !== undefined && model !== null) {
        const copy = {
          ...model,
          [entityIdName]: NumberUtils.castNumber(key),
        };
        fEntitiesRef[key] = copy;
        return fEntitiesRef;
      }
      fEntitiesRef[key] = null;
      return fEntitiesRef;
    },
    {},
  );

const primaryKeyNames = {
  matches: 'matchId',
  bets: 'betId',
  outcomes: 'oddId',
};

const normalize = (entities) =>
  reduce(
    ['matches', 'bets', 'outcomes'],
    (finalEntities, entity) => {
      if (entities[entity]) {
        const primaryKeyName = primaryKeyNames[entity];
        return {
          ...finalEntities,
          [entity]: normalizeEntities(entities[entity], primaryKeyName),
        };
      }
      return finalEntities;
    },
    entities,
  );

// Switch from decremental timer to incremental timer for handball
const getElapsedTimeFromRemainingTime = (time, matchStatus, match) => {
  // Gestion des prolongations nécessaire
  // 1h + potentiellement  - variabiliser en fonction de categoryId et à mettre en conf
  const totalTimeBasis = matchStatus === '1p_ot' || matchStatus === '2p_ot' ? 4200 : 3600;
  const remainingTimeParts = match.remainingTime.split(':');
  const remainingMinutes = parseInt(remainingTimeParts[0], 10);
  const remainingSeconds = parseInt(remainingTimeParts[1], 10);

  const totalRemainingSeconds = remainingMinutes * 60 + remainingSeconds;
  const initialTotalTime = totalTimeBasis;
  const elapsedTotalTimeSeconds = initialTotalTime - totalRemainingSeconds;
  const elapsedMinutesPart = Math.floor(elapsedTotalTimeSeconds / 60);
  const elapsedSecondsPart = elapsedTotalTimeSeconds - elapsedMinutesPart * 60;
  const formatedElapsedTime = `${elapsedMinutesPart}:${elapsedSecondsPart}`;

  time = formatedElapsedTime;

  return time;
};

export const extractMatchClock = (match) => {
  const {
    period,
    clockStopped,
    sportId,
    remainingTime,
    remainingTimeInPeriod,
    matchtime,
    matchtimeExtended,
    stoppageTime,
  } = match;
  const matchStatus = period;
  const matchClockStop = clockStopped;
  const isBasketBall = sportId === SportIds.BASKETBALL;
  const isHandball = sportId === SportIds.HANDBALL;
  const isAmericanFootball = sportId === SportIds.FOOTBALL;
  const isRugby = [SportIds.RUGBY, SportIds.RUGBY_LEAGUE_OLD, SportIds.RUGBY_7S_OLD].indexOf(sportId) > -1;
  const isAustralianFootball = sportId === SportIds.AUSSIE_RULES;
  const isIceHockey = sportId === SportIds.ICEHOCKEY;

  let type = null;
  let time = null;
  let showOnlyMinutes = false;

  if (matchtimeExtended !== undefined) {
    time = getTimerFromMatchTimeExtended(matchtimeExtended, stoppageTime);
    type = TIMER_INCREMENT;
  } else if ((isBasketBall || isAmericanFootball || isIceHockey) && remainingTimeInPeriod !== undefined) {
    time = remainingTimeInPeriod;
    type = TIMER_DECREMENT;
  } else if (isHandball && remainingTime !== undefined) {
    time = getElapsedTimeFromRemainingTime(time, matchStatus, match);
    type = TIMER_INCREMENT;
  } else if (remainingTime !== undefined) {
    time = remainingTime;
    type = TIMER_DECREMENT;
  } else if (matchtime !== undefined) {
    // NOTE: cas du rugby
    // (si il n'y a que le matchtime en rugby on affiche que les minutes)
    showOnlyMinutes = isRugby || isAustralianFootball;
    time = matchtime;
    type = TIMER_STOP;
  }

  if (time && type) {
    if (
      (matchStatus &&
        (matchStatus.indexOf('pause') > -1 || MatchStateUtils.matchStatusSimilarToPause.indexOf(matchStatus) > -1)) ||
      matchClockStop === true
    ) {
      type = TIMER_STOP;
      if (isHandball) {
        // Tester en se basant sur matchTime
        const handballParts = time.split(':');
        handballParts[1] = '00';
        time = handballParts.join(':');
      }
    }
    time = time.toString();

    let isAdditionalTime = false;
    let seconds = 0;

    if (time.indexOf('+') > -1) {
      const parts = time.split('+');

      // Temps additionel 45:00 +02:23
      time = parts[0].trim(); // On vient setter le time a 45
      if (type !== TIMER_STOP) {
        // Si type est != de stop, on doit incrémenter le temps additionel
        isAdditionalTime = true;
        seconds = MatchStateUtils.convertMatchTimeToSecond(parts[1].trim());
      } else {
        isAdditionalTime = false;
        // Sinon si type == stop, on affiche uniquement le temps réglementaire
        seconds = MatchStateUtils.convertMatchTimeToSecond(time);
      }
    } else {
      seconds = MatchStateUtils.convertMatchTimeToSecond(time);
    }

    return { type, time, seconds, isAdditionalTime, showOnlyMinutes };
  }
  return null;
};

const mergeEntitiesAndMutateOnlyIfNeeded = (entity, newEntity) =>
  reduce(
    newEntity,
    (finalEntities, value, key) => {
      // Entity already exist
      if (finalEntities[key] !== undefined && isPlainObject(finalEntities[key])) {
        // e.g. matches : { [id]: null }
        // mutate to null
        if (value === null) {
          finalEntities[key] = null;
          // e.g. matches : { [id]: { available: true } }
          // mutate to a new merge object
        } else {
          finalEntities[key] = { ...finalEntities[key], ...value };
        }
        return finalEntities;
      }
      // e.g. matches : { [id]: { available: true, ... } }
      // Entity doesn't exist
      finalEntities[key] = value;
      return finalEntities;
    },
    { ...entity },
  );

export default {
  normalize,
  convertToLowerCase,
  convertToString,
  extractMatchClock,
  mergeEntitiesAndMutateOnlyIfNeeded,
};
